define('controllers/consoleApi/oauthClient.apiDetail.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('OauthClientApiDetail', ['$q', '$scope', '$state', '$stateParams', '$rootScope', 'projectManageService', 'auiDialog', 'auiAgreementHelper', 'biAnalyticService',
        function ($q, $scope, $state, $stateParams, $rootScope, projectManageService, auiDialog, auiAgreementHelper, biAnalyticService) {
            var Model = $scope.Model = {
                userInfo: $scope.Model.userInfo,
                projectID: $stateParams.projectID,
                clientID: $stateParams.clientID,
                apiID: $stateParams.apiID,
                limitOauthClientInfo: {},
                checkedApi: {},
                checkedPermission: [],
                checkedPermissionTip: "",
                isViewPage: ($state.current.name == 'oauthClientApiView')
            };
            Model.signedAgreeList = [];
            var agreementArray = [];
            var agreementTypes = [];
            init();
            $scope.addApi = addApi;
            $scope.updateApi = updateApi;
            $scope.cancel = cancel;
            $scope.getApiDetail = getApiDetail;
            $scope.clickThisPermission = clickThisPermission;
            $scope.clickAllPermission = clickAllPermission;
            $scope.contains = AUI.BaseJSUtil.contains;

            Model.defaultProductTypeFilterMap = {};
            Model.openStateFilter = mainCons.oauthConstant.openStateFilter;
            Model.nameToApiInfo = {};
            mainCons.oauthConstant.productTypes.forEach(
                function (t) {
                    Model.defaultProductTypeFilterMap[t.prodType] = t["name"];
                }
            );
            function init() {
                if (!Model.isViewPage) {
                    if (Model.apiID == '0') {
                        biAnalyticService.trackPageView("APIConsole - 应用级客户端添加API页面", 'DPRM5067');
                    } else {
                        biAnalyticService.trackPageView("APIConsole - 应用级客户端修改API页面", 'DPRM5070');
                    }

                }

                if (!Model.projectID || !Model.clientID) {
                    cancel();
                } else {
                    projectManageService.getProjectInfo({projectID: Model.projectID}).then(function (data) {
                        if (data && data.projectInfo) {
                            Model.myProject = data.projectInfo;
                            initApi();
                        } else {
                            cancel();
                        }
                    });
                }
            }

            function initApi() {
                projectManageService.getProjectCredentialList(Model.myProject.projectID).then(function (oauthdata) {
                    if (oauthdata && oauthdata.limitOauthClientInfoList.length > 0) {
                        oauthdata.limitOauthClientInfoList.forEach(function (limitOauthClientInfo) {
                            if (limitOauthClientInfo.clientID == Model.clientID) {
                                Model.limitOauthClientInfo = limitOauthClientInfo;
                                Model.limitOauthClientInfo.clientIDName = limitOauthClientInfo.oauthClientAttr.clientName;
                                if (limitOauthClientInfo.prodType == '19' && limitOauthClientInfo.freeInstallType) {
                                    Model.limitOauthClientInfo.prodType = limitOauthClientInfo.prodType + '-' + limitOauthClientInfo.freeInstallType;
                                }
                                Model.limitOauthClientInfo.prodTypeName = Model.defaultProductTypeFilterMap[Model.limitOauthClientInfo.prodType + ''];
                                if (Model.apiID == '0') {
                                    projectManageService.getAllCanAddApi(Model.projectID, Model.clientID).then(function (kitsApiList) {
                                        Model.kitsApiList = kitsApiList;
                                        Model.apiNameList = [];
                                        Model.kitsApiList.forEach(function (kitsApi) {
                                            Model.nameToApiInfo[kitsApi.langInfo.apiName] = kitsApi;
                                            Model.apiNameList.push(kitsApi.langInfo.apiName);
                                        });
                                        Model.checkedApi = Model.kitsApiList[0];
                                        Model.checkedApiName = Model.apiNameList[0];
                                        getApiDetail();
                                    });
                                } else {
                                    projectManageService.getOauthAPI(Model.projectID, Model.clientID).then(function (resp) {
                                        if (resp && resp.oauthApiList && resp.oauthApiList.length > 0) {
                                            resp.oauthApiList.forEach(function (oauthApi) {
                                                if (oauthApi.apiID == Model.apiID) {
                                                    Model.checkedApi = oauthApi;
                                                    getApiDetail(oauthApi);
                                                }
                                            })
                                        }
                                    });
                                }
                            }
                        });
                    } else {
                        cancel();
                    }
                });
            }

            //提交
            function addApi(isValid) {
                $scope.oauthClientApiForm.$setDirty();
                if ($scope.oauthClientApiForm.checkedPermissionType) {
                    $scope.oauthClientApiForm.checkedPermissionType.$setDirty();
                }
                if ($scope.oauthClientApiForm.remarks) {
                    $scope.oauthClientApiForm.remarks.$setDirty();
                }
                var defer = $q.defer();
                if (isValid) {
                    auiAgreementHelper.checkAgreements(agreementArray, function () {
                        defer.resolve();
                    }, $scope.Model.userInfo, true).then(function (res) {
                        if (res && res.signed) {
                            var apiInfo = {};
                            if (Model.checkedPermission && Model.checkedPermission.length > 0) {
                                apiInfo = {
                                    apiID: Model.checkedApi.apiID,
                                    oauthAPIAttrs: angular.toJson({
                                        itemIDList: Model.checkedPermission
                                    }),
                                    remarks:Model.checkedApi.remarks
                                }
                            } else {
                                apiInfo = {
                                    apiID: Model.checkedApi.apiID
                                }
                            }
                            projectManageService.addOauthAPI(Model.clientID, apiInfo).then(function () {
                                auiDialog.success('提交成功', function () {
                                    cancel();
                                    defer.resolve();
                                });
                            }).catch(function (e) {
                                defer.reject();
                            });
                        } else {
                            defer.reject();
                        }
                    }).catch(function (e) {
                        defer.reject();
                    });

                } else {
                    defer.reject();
                }
                return defer.promise;
            }


            //提交
            function updateApi(isValid) {
                $scope.oauthClientApiForm.$setDirty();
                if ($scope.oauthClientApiForm.checkedPermissionType) {
                    $scope.oauthClientApiForm.checkedPermissionType.$setDirty();
                }
                if ($scope.oauthClientApiForm.remarks) {
                    $scope.oauthClientApiForm.remarks.$setDirty();
                }
                var defer = $q.defer();
                if (isValid) {
                    try{
                        auiAgreementHelper.checkAgreements(agreementArray, function () {
                        }, $scope.Model.userInfo, true).then(function (res) {
                            if (res && res.signed) {
                                projectManageService.modOauthAPI(Model.clientID, {
                                    apiID: Model.checkedApi.apiID,
                                    oauthAPIAttrs: angular.toJson({
                                        itemIDList: Model.checkedPermission
                                    }),
                                    remarks:Model.checkedApi.remarks
                                }).then(function () {
                                    auiDialog.success('提交成功', function () {
                                        cancel();
                                        defer.resolve();
                                    });
                                },function () {
                                    defer.reject();
                                });
                            } else {
                                defer.reject();
                            }
                        },function () {
                            defer.reject();
                        });
                    }catch(e){
                        defer.reject();
                    }

                } else {
                    defer.reject();
                }
                return defer.promise;
            }


            //获取API详情
            function getApiDetail(oauthApi) {
                Model.checkedPermission = [];
                agreementArray = [];
                agreementTypes = [];
                Model.checkedPermissionTip = "";
                if (Model.apiID == '0') {
                    Model.checkedApi = Model.nameToApiInfo[Model.checkedApiName]
                }
                projectManageService.getAPIDetail(Model.checkedApi.apiID).then(function (resp) {
                    if (oauthApi && oauthApi.oauthAPIAttrs) {
                        oauthApi.oauthAPIAttrs = angular.fromJson(oauthApi.updateOauthAPIAttrs) || angular.fromJson(oauthApi.oauthAPIAttrs);
                        if (oauthApi.oauthAPIAttrs.itemIDList) {
                            Model.checkedPermission = oauthApi.oauthAPIAttrs.itemIDList;
                            Model.checkedPermissionTip = oauthApi.apiID;
                        }
                    }
                    Model.checkedApi.apiInfo = angular.copy(resp.apiDetail);
                    Model.apiInfo = resp.apiDetail;
                    if (Model.apiInfo.langInfo && Model.apiInfo.langInfo.displayAttrs) {
                        Model.apiInfo.langInfo.displayAttrs = angular.fromJson(Model.apiInfo.langInfo.displayAttrs);
                        if (Model.apiInfo.langInfo.displayAttrs.permissionDisplay && Model.apiInfo.langInfo.displayAttrs.permissionDisplay.content
                            && Model.apiInfo.langInfo.displayAttrs.permissionDisplay.content.length > 0
                        ) {
                            Model.checkedApi.permissionDisplay = Model.apiInfo.langInfo.displayAttrs.permissionDisplay;
                            if (Model.checkedApi.permissionDisplay.content && Model.checkedApi.permissionDisplay.content.length > 0) {
                                Model.kindNameList = [];
                                Model.checkedApi.permissionDisplay.content.forEach(function (item) {
                                    if (!AUI.BaseJSUtil.contains(Model.kindNameList, item.kindName)) {
                                        Model.kindNameList.push(item.kindName);
                                    }
                                });
                                if (Model.checkedPermission) {
                                    Model.kindNameListView = [];
                                    Model.checkedApi.permissionDisplay.content.forEach(function (item) {
                                        if (!AUI.BaseJSUtil.contains(Model.kindNameListView, item.kindName) && AUI.BaseJSUtil.contains(Model.checkedPermission, item.itemID)) {
                                            Model.kindNameListView.push(item.kindName);
                                        }
                                    });
                                }
                            }
                        } else {
                            Model.checkedApi.permissionDisplay = {};
                        }
                        if (!Model.isViewPage && Model.apiInfo.langInfo.displayAttrs.serviceterms && Model.apiInfo.langInfo.displayAttrs.serviceterms.content && Model.apiInfo.langInfo.displayAttrs.serviceterms.content.length > 0) {
                            Model.apiInfo.langInfo.displayAttrs.serviceterms.content.forEach(function (agree) {
                                if (agree.agreementType) {
                                    agreementArray.push({agrType: agree.agreementType, country: 'cn', count: 1});
                                    agreementTypes.push(agree.agreementType);
                                }
                            });
                            projectManageService.getIsSignAgreement(agreementTypes).then(function (data) {
                                if (data && data.signInfoList && data.signInfoList.length > 0) {
                                    data.signInfoList.forEach(function (signInfo) {
                                        if ((signInfo.signStatus == 2 || signInfo.signStatus == 1)) {
                                            Model.signedAgreeList.push(signInfo.agrType);
                                        }
                                    });
                                }
                            });
                        }
                    } else {
                        Model.checkedApi.permissionDisplay = {};
                    }
                });
            }

            //取消
            function cancel() {
                $state.go('oauthClientApiList', {
                    projectID: Model.projectID,
                    clientID: Model.clientID
                }, {reload: true});
            }

            function clickThisPermission(permission) {
                if (AUI.BaseJSUtil.contains(Model.checkedPermission, permission.itemID)) {
                    AUI.BaseJSUtil.arrayRemove(Model.checkedPermission, permission.itemID);
                    if (Model.checkedPermission.length == 0) {
                        Model.checkedPermissionTip = ''
                    }
                } else {
                    Model.checkedPermission.push(permission.itemID);
                    Model.checkedPermissionTip = permission.itemID;
                }
            }

            function clickAllPermission() {
                if (Model.checkedPermission.length == 0 || Model.checkedPermission.length < Model.checkedApi.permissionDisplay.content.length) {
                    Model.checkedPermission = [];
                    Model.checkedApi.permissionDisplay.content.forEach(function (item) {
                        Model.checkedPermission.push(item.itemID);
                        Model.checkedPermissionTip = item.itemID;
                    });
                } else {
                    Model.checkedPermission = [];
                    Model.checkedPermissionTip = ''
                }
            }
        }
    ]);
});

